import { ArticleRepository } from "./articles/secondary/Article.secondary";
import { DocumentationsRepository } from "./documentation/secondary/Documentation.repository";
import { TermsAndConditionsRepository } from "./termsAndConditions/secondary/TermsAndConditions.repository";

// All Directus repo are exposed through this object
// Because we can't pass a class from server component to client
// If using context, it would only be usable on client component and we don't want that
export const directusDependanciesInjectionRepositories = {
  termsAndConditionsRepo: new TermsAndConditionsRepository(),
  documentationsRepo: new DocumentationsRepository(),
  articleRepo: new ArticleRepository(),
};

export const ARTICLES_TO_DISPLAY = {
  WHY_AGENTS_MATTER: {
    "fr-FR": {
      slug: "comment-un-chatbot-peut-transformer-lexperience-client-sur-votre-site-e-commerce",
      title:
        "Comment un chatbot peut transformer l'expérience client sur votre site e-commerce ",
    },
    "en-US": {
      slug: "how-a-chatbot-can-transform-the-customer-experience-on-your-e-commerce-site",
      title:
        "How a chatbot can transform the customer experience on your e-commerce site ",
    },
  },
  HOW_TO_IMPLEMENT: {
    "fr-FR": {
      slug: "comment-mettre-en-place-notre-chatbot-sur-votre-site-web-",
      title: "Comment mettre en place le chatbot sur votre site web ?",
    },
    "en-US": {
      slug: "how-to-implement-our-chatbot-on-your-website",
      title: "How to implement the chatbot on your website?",
    },
  },
  RETROGAMEPLACE_CASESTUDY: {
    "fr-FR": {
      slug: "limpact-concret-de-laugmentation-de-donnees-sur-un-site-e-commerce-etude-de-cas-retro-game-place",
      title:
        "L'impact concret de l'augmentation de données sur un site e-commerce : étude de cas Retro Game Place",
    },
    "en-US": {
      slug: "the-concrete-impact-of-data-augmentation-on-an-e-commerce-site-retro-game-place-case-study",
      title:
        "The concrete impact of data augmentation on an e-commerce site: Retro Game Place case study",
    },
  },
};
